import { DecoratorNode, $applyNodeReplacement } from 'lexical';
import * as React from 'react';
import { Suspense } from 'react';

const TableOfContentsComponent = React.lazy(() => import('./TableOfContentsComponent'));

export class TableOfContentsNode extends DecoratorNode {
  static getType() {
    return 'table-of-contents';
  }

  static clone(node) {
    return new TableOfContentsNode(node.__key);
  }

  static importJSON() {
    return $createTableOfContentsNode();
  }

  exportJSON() {
    return {
      type: 'table-of-contents',
      version: 1,
    };
  }

  constructor(key) {
    super(key);
  }

  createDOM() {
    const div = document.createElement('div');
    div.className = 'toc-block-container';
    return div;
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return (
      <Suspense fallback={null}>
        <TableOfContentsComponent nodeKey={this.getKey()} />
      </Suspense>
    );
  }
}

export function $createTableOfContentsNode() {
  return $applyNodeReplacement(new TableOfContentsNode());
}

export function $isTableOfContentsNode(node) {
  return node instanceof TableOfContentsNode;
}
